import '../payment-message-dialog.scss';

export default class ConfirmationCtrl {

    // @ngInject
    constructor(signupDataStore) {
        this.email = signupDataStore.account.email;
    }

    next() {
        window.location.reload();
    }

}



// WEBPACK FOOTER //
// ./payments/confirmation/confirmation-ctrl.js